module.exports = __webpack_public_path__ + "static/media/gallery-img-6.c1594ae3.jpg";